import { pushEventAndTrack } from '../../helpers/taggingSerializer'

const build = ({ eventAction, clickOrigin, productID, wishlistType = undefined, isAddedOrRemoved = undefined }) => ({
  eventInfo: {
    eventName: 'wishlist_interaction',
    eventAction: `Wishlist Interaction - ${eventAction}`
  },
  attributes: {
    clickOrigin,
    customSiteSection: 'pdp',
    productID,
    isAddedOrRemoved,
    wishlistType
  }
})

const fireWishlistToggled = ({ partNumber, isChecked, userState }) => {
  const options = {
    eventAction: 'Add to Wishlist Button',
    clickOrigin: 'addToWishlistButton',
    productID: partNumber,
    isAddedOrRemoved: isChecked ? 'removed' : 'added',
    wishlistType: userState === 'LOGGEDIN' ? 'service' : 'local'
  }
  pushEventAndTrack(build(options))
}

// eslint-disable-next-line import/prefer-default-export
export { fireWishlistToggled }
